// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Generate govinfo.gov URLs for bill text versions.
 */

const GOVINFO_BASE = 'https://www.govinfo.gov/content/pkg'
const EXT_MAP: Record<string, string> = { pdf: 'pdf', xml: 'xml', html: 'htm' }

/** Generate a govinfo URL for a bill text version. */
export function govinfoUrl(
  congress: number,
  billType: string,
  billNumber: string,
  suffix: string,
  fmt: 'pdf' | 'xml' | 'html',
): string {
  const pkg = `BILLS-${congress}${billType.toLowerCase()}${billNumber}${suffix}`
  const ext = EXT_MAP[fmt]
  return `${GOVINFO_BASE}/${pkg}/${fmt}/${pkg}.${ext}`
}
